import React from 'react';
import './index.scss';

const MapVariableIssue: React.FC<any> = ({ message, visible }) => {
  if (!visible) return null;

  return (
    <div className="attention-warning-message">
      <i className="issue-icon"></i>
      <span className="issue-text">{message}</span>
    </div>
  );
};

export default React.memo(MapVariableIssue);
